import React from "react";
import { motion } from "framer-motion";

export const LtContact = () => {
  // === ANIMASI ITEM KONTAK (STAGGER) ===
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const contactInfo = [
    {
      id: 1,
      icon: (
        <svg
          className="w-5 h-5 text-slate-600"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
      ),
      title: "Email",
      content: "contact@vionixasia.com",
      link: "mailto:contact@vionixasia.com",
    },
    {
      id: 2,
      icon: (
        <svg
          className="w-6 h-6 text-slate-600"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
        </svg>
      ),
      title: "Phone",
      content: "+62 812-1230-3426",
      link: "tel:+6281212303426",
    },
    {
      id: 3,
      icon: (
        <svg
          className="w-6 h-6 text-slate-600"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
      ),
      title: "Location",
      content: "Jakarta, Indonesia",
      link: "#",
    },
  ];

  return (
    <section
      id="contact"
      className="w-full py-16 lg:py-24 px-4 bg-white border-t border-slate-200 overflow-hidden"
    >
      <motion.div
        className="w-full max-w-6xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        {/* ===== HEADER: Judul Utuh + Deskripsi Berurutan ===== */}
        <div className="text-center mb-10">
          <motion.h2
            className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Contact Us
          </motion.h2>

          <motion.p
            className="text-gray-600 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            Get in touch to learn more about our solutions, discuss potential collaboration opportunities, or simply ask a question. Our team is here to help.
          </motion.p>
        </div>

        {/* Kontak – Mobile: vertikal, Desktop: horizontal */}
        <motion.div
          className="flex flex-col sm:flex-row sm:justify-center items-start sm:items-center gap-8 lg:gap-16"
          variants={{
            visible: {
              transition: { staggerChildren: 0.15, delayChildren: 0.3 },
            },
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {contactInfo.map((info) => (
            <motion.a
              key={info.id}
              href={info.link}
              className="flex items-center gap-3 group w-full sm:w-auto"
              variants={itemVariants}
              whileHover={{ x: 4 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              {/* Icon */}
              <motion.div
                className="w-10 h-10 bg-slate-100 border border-slate-200 flex items-center justify-center rounded-icon flex-shrink-0"
                whileHover={{ scale: 1.1, rotate: 12 }}
                transition={{ type: "spring", stiffness: 400 }}
              >
                {info.icon}
              </motion.div>

              <div className="flex-1">
                <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider">
                  {info.title}
                </h3>
                <p className="text-base font-medium text-slate-900 break-all">
                  {info.content}
                </p>
              </div>
            </motion.a>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};
